import React, { useEffect, useRef, useState } from 'react';
import {
  TextField,
  Button,
  Typography,
  InputAdornment,
  IconButton,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { forgetPassword, signIn } from '../../features/auth/authSlice';
import { useDispatch } from 'react-redux';
import Spinner from '../../components/UIElements/Spinner';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { getMenuItems } from '../../components/UIElements/sidebarConfig';
import { logout } from '../../utils/logout';

const Signin = () => {
  const divRef = useRef();
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [type, setType] = useState('login');
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [password, setPassword] = useState(false);
  const [error, setError] = useState(null);
  async function clearState() {
    await logout();
  }
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (type === 'login') {
      try {
        const response = await dispatch(signIn(formData)).unwrap();
        if (response.status === 200 && typeof response?.data === 'object') {
          const MENU_ITEMS = getMenuItems(
            response?.data?.userDetails,
            response?.data?.userPermissions,
            response?.data?.webServices,
          );
          const firstRoute = MENU_ITEMS?.[0]?.route;
          localStorage.setItem(
            'userName',
            response?.data?.userDetails?.userName,
          );
          localStorage.setItem(
            'smsService',
            response?.data?.userDetails?.smsService,
          );
          localStorage.setItem('access_token', response?.data?.access_token);
          localStorage.setItem(
            'startDate',
            response?.data?.userDetails?.academicStart,
          );
          localStorage.setItem(
            'endDate',
            response?.data?.userDetails?.academicEnd,
          );
          navigate(firstRoute);
        } else {
          setError('Something went wrong. Please try again later .');
        }
      } catch (error) {
        if (error?.status === 401) {
          setError('Invalid Credentials! Enter Valid Details');
        } else if (error?.status === 423)
          setError('Access denied,Please contact @support team');
        else {
          setError('Something went wrong. Please try again.');
        }
      } finally {
        setLoading(false);
      }
    } else {
      try {
        const response = await dispatch(
          forgetPassword(formData?.email),
        ).unwrap();
        if (response?.status === 200) {
          alert(
            'Please check your email to know the about your login detials !',
          );
          setError('');
          setFormData({
            email: '',
            password: '',
          });
        }
        if (response?.status === 203) {
          setError('Invalid email Id! Enter valid email');
        }
      } catch (error) {
        {
          setError('Something went wrong. Please try again.');
        }
      } finally {
        setLoading(false);
      }
    }
  };
  useEffect(() => {
    const div = divRef.current;
    if (!div) return;
    // Create a ResizeObserver to watch the div
    const resizeObserver = new ResizeObserver((entries) => {
      const { width, height } = entries[0].contentRect;
      setDimensions({ width, height, isSmall: height < 400 });
    });
    resizeObserver.observe(div);
    //clear the store  in case of any data present in the store
    clearState();
    // Cleanup on unmount
    return () => resizeObserver.disconnect();
  }, []);
  return (
    <>
      <div className='flex  size-full   rounded-3xl shadow-md' ref={divRef}>
        <div className='flex-1 max-md:hidden'>
          <img
            src='../../login-cover-page.png'
            className='object-fill size-full rounded-l-3xl '
          ></img>
        </div>

        <div
          className='bg-white flex-1 max-[400px]:p-2 h-full max-md:w-full flex flex-col  justify-center
                max-md:rounded-3xl rounded-r-3xl overflow-hidden  text-center'
        >
          {!dimensions?.isSmall && (
            <img
              src='/images/SVClassEdge.png'
              className='max-h-20 h-auto block w-[200px] object-fill mx-auto'
            ></img>
          )}

          <Typography className='text-2xl font-semibold my-0 '>
            {' '}
            Welcome Back!
          </Typography>
          <Typography className='text-base font-normal m-0 mb-2'>
            One step behind for your Application
          </Typography>

          {loading && <Spinner asOverlay={true} />}
          {error && (
            <Typography className='text-red-600 text-center mb-1'>
              {error}
            </Typography>
          )}
          <form
            onSubmit={handleSubmit}
            className='space-y-3 max-w-sm  md:px-8 block mx-auto'
          >
            <TextField
              fullWidth
              label='Email'
              name='email'
              type='email'
              size={dimensions?.isSmall ? 'small' : ''}
              value={formData.email}
              onChange={handleChange}
              required
              className='bg-white'
            />

            {type === 'login' && (
              <TextField
                fullWidth
                autoComplete='off'
                label='Password'
                size={dimensions?.isSmall ? 'small' : ''}
                name='password'
                type={password ? 'text' : 'password'}
                value={formData.password}
                onChange={handleChange}
                required
                InputProps={{
                  className: 'bg-white',
                  endAdornment: (
                    <InputAdornment position='end'>
                      <IconButton
                        onClick={() => setPassword((show) => !show)}
                        edge='end'
                        size='small'
                      >
                        {password ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                className='bg-white'
              />
            )}

            <Button
              type='submit'
              variant='contained'
              fullWidth
              className='bg-blue-600 hover:bg-blue-700 py-2'
            >
              {type === 'forget' ? 'Submit' : 'Sign In'}
            </Button>
            {type === 'login' && (
              <Typography
                className='text-blue-600 mr-auto cursor-pointer hover:underline'
                onClick={() => {
                  (setType('forget'),
                    setFormData({
                      email: '',
                      password: '',
                    }),
                    setError(''));
                }}
              >
                Forget Password?
              </Typography>
            )}
            {type === 'forget' && (
              <Typography
                className='text-blue-600 cursor-pointer hover:underline'
                onClick={() => {
                  (setType('login'),
                    setFormData({
                      email: '',
                      password: '',
                    }),
                    setError(''));
                }}
              >
                Back to SignIn
              </Typography>
            )}
          </form>
          <Typography className='text-gray-600'>
            Don't have an account?{' '}
            <span
              onClick={() => navigate('/registration')}
              className='text-blue-600 cursor-pointer hover:underline'
            >
              SignUp Here
            </span>
          </Typography>
        </div>
      </div>
    </>
  );
};

export default Signin;
